<template>
  <div class="banner">
    <div class="common-level-rail fl">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/setting/banner/add'">添加banner</el-button>
      <el-select v-model="searchObj.biz_type" placeholder="业务场景" clearable size="small" style="width: 140px; margin-left: 10px;" @change="getData">
        <el-option label="全部场景" :value="null"></el-option>
        <el-option v-for="item in bizTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="biz_type" label="业务场景" width="110">
            <template slot-scope="scope">
              <span>{{ getBizTypeLabel(scope.row.biz_type) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_path" label="轮播图">
            <template slot-scope="scope">
              <el-image :src="scope.row.file_path" :preview-src-list="[scope.row.file_path]" alt="" fit="contain" style="width: 160px; height: 80px;" />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sort" label="位置">
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.position==1" type="primary">顶部轮播</el-tag>
              <el-tag size="small" v-else type="warning">商品推荐</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.status==1" type="success">开启</el-tag>
              <el-tag size="small" v-else type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <div class="cell">
                <el-button type="text" size="small" @click="editBanner(scope.row)" v-auth="'/setting/banner/edit'">编辑</el-button>
                <el-button type="text" size="small" @click="deleteBanner(scope.row)" v-auth="'/setting/banner/delete'">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>


      <div class="pagination">
        <el-pagination @current-change="pageChange" background :current-page="searchObj.page"
          :page-size="searchObj.pageSize" layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

    </div>

    <el-dialog :visible.sync="dialogShow" :title="type=='add'?'新增轮播图':'编辑轮播图'" destroy-on-close	width="700px">
      <modifyBanner :show.sync="dialogShow" @save="bannerRefresh" ref="modifyBannerRef" :biz-type-options="bizTypeOptions"></modifyBanner>
    </el-dialog>


  </div>
</template>

<script>
import modifyBanner from './modifyBanner.vue'
import BannerAPi from '@/api/banner.js';
// import ArticleApi from '@/api/article.js';
export default {
  components:{modifyBanner},
  data(){
    return{
      dialogShow:false,
      tableData:[],
      searchObj:{
        list_rows:15,
        page:1,
        biz_type: null,
      },
      total:10,
      type:'',
      bizTypeOptions:[],
    }
  },
  created(){
    this.getBizTypeOptions()
    this.getData()
  },
  methods:{
    // 获取业务场景选项
    getBizTypeOptions(){
      BannerAPi.bannerBizTypeOptions().then(result=>{
        this.bizTypeOptions = result.data.options || []
      })
    },
    // 查询
    getData(){
      const params = { ...this.searchObj }
      if (params.biz_type == null || params.biz_type === '') delete params.biz_type
      BannerAPi.bannerList(params).then(result=>{
        let list=result.data.list
        this.tableData=list.data
        this.total=list.total
      })
    },
    getBizTypeLabel(value){
      if (value == null || value === '' || value === 0) return ''
      // 列表数据 biz_type 可能是字符串，选项 value 可能是数字，统一转数字比较
      const val = Number(value)
      if (Number.isNaN(val)) return ''
      const opt = (this.bizTypeOptions || []).find(o => Number(o.value) === val)
      return opt ? opt.label : ''
    },
    // 分页切换
    pageChange(e){
      // console.log(e);
      this.searchObj.page=e
      this.getData()
    },

    // 添加
    addClick(){
      this.type='add'
      this.dialogShow=true
    },

    // 编辑
    editBanner(e){
      // console.log(e);
      this.type='edit'
      this.dialogShow=true
      this.$nextTick(()=>{
        this.$refs.modifyBannerRef.getData(e.id)
      })
    },

    // 删除
    deleteBanner(e){
      let self = this;
      self.$confirm('确认删除当前轮播图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        BannerAPi.bannerDelete({id:e.id}).then(result=>{
          self.$message({
            message: '删除成功',
            type: 'success'
          });
          this.bannerRefresh()
        })
      })
    },

    bannerRefresh(){
      this.getData()
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/setting/banner/index.vue